import Regex from "./regex";

const { AccountName, PrivateKey, PublicKey, CompositionName, FieldName } = Regex;

export const testPermissionName = (value) => {
    return AccountName.test(value);
}

export const validateIndexName = (value) => {
    return AccountName.test(value);
}

export const valiedateNameField = (value) => {
    return AccountName.test(value);
}

export const testPrivateKey = (value) => {
    return PrivateKey.test(value);
}

export const testPublicKey = (value) => {
    return PublicKey.test(value);
}

export const validateURL = (url) => {
    try {
        const parsedURL = new URL(url);
        return parsedURL.protocol === 'http:' || parsedURL.protocol === 'https:';
    } catch (e) {
        return false;
    }
}

export const validateMultiFormatFile = (format) => {
    switch (format) {
        case "json":
        case "csv":
        case "xml":
            return true;
        default:
            return false;
    }
}

const cppReservedKeywords = new Set(["class", "bool", "false", "true"]);

/**
 * Zašto ime kompozicije nije prihvatljivo — `null` kad jeste.
 *
 * `validateCompositionName` vraća samo tačno/netačno, pa je pozivalac koji
 * hoće da kaže korisniku šta ne valja morao sam da pogađa. Rezultat je bio
 * dugme koje na klik ne uradi ništa i ne kaže zašto.
 *
 * @param {string} value
 * @param {Set<string>} compositions  imena koja u bazi već postoje
 * @returns {string|null}
 */
export const compositionNameProblem = (value, compositions) => {
    if (typeof value !== 'string' || value.trim() === '') {
        return 'Enter a name for the composition.';
    }
    if (value !== value.trim()) {
        return 'The name starts or ends with a space.';
    }
    if (cppReservedKeywords.has(value.toLowerCase())) {
        return `'${value}' is a reserved word and cannot be used as a composition name.`;
    }
    if (compositions?.has(value)) {
        return `Composition '${value}' already exists in this database. An import can add `
            + 'compositions, but cannot change an existing one.';
    }
    if (!CompositionName.test(value)) {
        return `'${value}' is not a usable composition name (1 to 32 characters).`;
    }
    return null;
}

export const validateCompositionName = (value, compositions) =>
    compositionNameProblem(value, compositions) === null;

export const validateFieldName = (value) => {
    return FieldName.test(value);
}